import React from 'react';
import { CopyButton, DataTable } from '@gov-nx/ui/web';

interface TableProps {
	data: [
		label: string,
		value?: string,
		options?: { copyValueLabel?: string },
	][];
}

export const Table = ({ data }: TableProps) => (
	<DataTable responsive>
		<tbody>
			{data.map(([label, value, options]) => (
				<tr key={`${label}-${value}`}>
					<td className="sm:w-1/2">{label}</td>
					<td className="sm:w-1/2">
						<strong>{value || '-'}</strong>
						{value && options?.copyValueLabel && (
							<CopyButton
								value={value}
								label={options.copyValueLabel}
							/>
						)}
					</td>
				</tr>
			))}
		</tbody>
	</DataTable>
);
